import { DownOutlined, EditOutlined, FolderOutlined } from '@ant-design/icons'
import { Dropdown, Menu, Progress, Typography } from 'antd'
import { round } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Favorite, UserName, getPointPermission } from '@/components'
import { HotResource } from '@/components/hot-resource/hot-resource.component'
import { PortfolioEdit } from '@/modules/portfolio/portfolio-create'
import { PAGE_RESOURCE_POINTS_ENUM, Portfolio } from '@/schemas'

interface PortfolioHeaderProps {
  portfolio: Portfolio
  refresh: () => void
}

export const PortfolioHeader: React.FC<PortfolioHeaderProps> = ({ portfolio, refresh }) => {
  const { t } = useTranslation()
  const { canUpdate } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况, portfolio.permissions)

  // 修复触发 Popconfirm 时 Menu 被自动关闭
  const [visible, setVisible] = React.useState(false)
  const [editVisible, setEditVisible] = React.useState(false)

  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'edit') {
          setEditVisible(true)
          setVisible(false)
        }
      }}
    >
      <Menu.Item key='edit' icon={<EditOutlined />} disabled={!canUpdate}>
        {t('portfolio.editInfo')}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className='flex space-x-16px text-sm items-baseline'>
      <div>
        <FolderOutlined style={{ fontSize: 18 }} />
      </div>
      <Dropdown trigger={['click']} overlay={menu} visible={visible} onVisibleChange={(visible) => setVisible(visible)}>
        <Typography.Text ellipsis className='cursor-pointer text-xl'>
          {portfolio.name}
          <DownOutlined className='ml-4px' />
        </Typography.Text>
      </Dropdown>
      <div>
        <HotResource selfId={portfolio.selfId} type={portfolio.type} />
      </div>
      <div>
        <Favorite selfId={portfolio.selfId} type={portfolio.type} isFavourited={portfolio.isFavourited} />
      </div>
      <div>
        <UserName email={portfolio.email} />
      </div>
      <div>
        <Progress className='font-mono flex-shrink-0' type='circle' width={26} percent={round(portfolio.progress, 0)} />
      </div>
      <PortfolioEdit
        portfolio={portfolio}
        visible={editVisible}
        onCancel={() => {
          setEditVisible(false)
          refresh()
        }}
      />
    </div>
  )
}
